module.exports = __webpack_public_path__ + "img/font-title.6cb0689f.png";